import { uploadFooterImage } from "../utils/api/uploadApi";

export const FOOTER_INITIAL_FORM = {
  files: null,
  name: "",
  phone: "",
  skype: "",
  mail: "",
  job: "",
};

export const FOOTER_DROPZONE_ACCEPT = {
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
  "image/avif": [".avif"],
  "video/webm": [".webm"],
};

const IMAGE_WAIT_MESSAGE = "Czeka na zaladowanie na serwer";
const IMAGE_SUCCESS_MESSAGE = "Zdjecie poprawnie dodane na serwer!";
const IMAGE_FAIL_MESSAGE = "Nie udalo sie dodac zdjecia";
const UPLOAD_FAIL_MESSAGE = "Blad podczas wysylania danych: ";

export const createPhoneNum = (txt) =>
  txt?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") || "";

export const handleFooterDrop = ({ acceptedFile, setFile, setPreview, setImageInfo }) => {
  const selectedFile = acceptedFile[0];
  if (!selectedFile) return;

  setFile(selectedFile);
  setPreview(URL.createObjectURL(selectedFile));
  setImageInfo(IMAGE_WAIT_MESSAGE);
};

export const copySignatureToClipboard = async (iframeRef) => {
  if (!iframeRef?.current?.srcdoc) return;

  const clipboardItem = new ClipboardItem({
    "text/plain": new Blob([iframeRef.current.srcdoc], { type: "text/plain" }),
    "text/html": new Blob([iframeRef.current.srcdoc], { type: "text/html" }),
  });

  await navigator.clipboard.write([clipboardItem]);
};

export const submitFooterImage = async ({
  file,
  setLoading,
  setMessage,
  setImageInfo,
}) => {
  if (!file) {
    alert("Dodaj zdjecie przed wysylka.");
    return false;
  }

  const payload = new FormData();
  payload.append("file", file);

  setLoading(true);

  try {
    const response = await uploadFooterImage(payload);

    if (!response.ok) {
      throw new Error("Upload failed!");
    }

    setMessage(response?.data?.remoteFolderPath || "");
    setImageInfo(IMAGE_SUCCESS_MESSAGE);
    return true;
  } catch (error) {
    setImageInfo(IMAGE_FAIL_MESSAGE);
    alert(UPLOAD_FAIL_MESSAGE + error.message);
    return false;
  } finally {
    setLoading(false);
  }
};
